import { GlovoJSON } from '@glovo/runtime-utils';
import { getDefaultRequestHeaders } from './get-default-request-headers';
import { GlovoApiError } from './glovo-api-error';
export function createGlovoClient(client, config) {
    const clone = client.create({
        ...config,
        headers: {
            ...config.headers,
            ...getDefaultRequestHeaders(config),
        },
        transformResponse: [
            (data) => {
                try {
                    return GlovoJSON.parse(data);
                }
                catch {
                    return data;
                }
            },
        ],
    });
    clone.interceptors.request.use((requestConfig) => {
        const requestTTL = requestConfig.requestTTL;
        if (requestTTL) {
            requestConfig.headers['Glovo-Request-TTL'] = requestTTL;
        }
        return requestConfig;
    });
    clone.interceptors.response.use(undefined, (error) => {
        const { config: errorConfig = {} } = error;
        const useGlovoApiError = (config.useGlovoApiError && !('useGlovoApiError' in errorConfig)) ||
            errorConfig.useGlovoApiError;
        if (useGlovoApiError) {
            return Promise.reject(GlovoApiError.from(error));
        }
        return Promise.reject(error);
    });
    return clone;
}
//# sourceMappingURL=create-glovo-client.js.map